import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header pl-24 pr-24" }
const _hoisted_2 = { class: "d-flex flex-row-reverse align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_4 = { class: "d-flex align-items-center p-2" }
const _hoisted_5 = { class: "d-flex justify-content-between" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "parent" }
const _hoisted_8 = { class: "mt-80 mb-50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_gray_text = _resolveComponent("gray-text")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_QuizFilters = _resolveComponent("QuizFilters")!
  const _component_document_card_checkbox = _resolveComponent("document-card-checkbox")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { "no-sidebar": true }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "d-flex justify-content-center" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isAllPartnerDataDownloading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_ProgressBar, { progress: _ctx.downloadProgress }, null, 8, ["progress"]),
                  _createVNode(_component_gray_text, { class: "ml-10 mt-10 fz-14" }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("Generate and Download in progress...", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createVNode(_component_base_button, {
                  variant: "outlined",
                  onClick: _ctx.abortDownload
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("Cancel download", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_base_button, {
            class: "ml-18",
            disabled: _ctx.isAllPartnerDataDownloading || _ctx.savedQuizIds.length === 0,
            onClick: _ctx.save
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Start Download", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_base_button, {
            variant: "outlined",
            onClick: _ctx.cancel
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "heading-4 f-roboto fw-light grey-1 mb-32" }, "Download data for selected partners", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_base_button, {
            class: "mr-16",
            variant: "outlined",
            onClick: _ctx.selectAll
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Select all", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_base_button, {
            variant: "outlined",
            onClick: _ctx.deselectAll
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Deselect all", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_QuizFilters, { onOnFilterChange: _ctx.onFilterChange }, null, 8, ["onOnFilterChange"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
          return (_openBlock(), _createElementBlock("div", {
            key: document.id,
            class: "child"
          }, [
            _createVNode(_component_document_card_checkbox, {
              id: document.id,
              name: document.name,
              "gradient-type": document.color,
              "last-edited": document.updated_at,
              "filter-values": document.filter_values,
              "business-function-id": _ctx.businessFunctionId,
              "is-selected": _ctx.savedQuizIds.indexOf(document.id) !== -1,
              onOnCheck: _ctx.toggleQuiz
            }, null, 8, ["id", "name", "gradient-type", "last-edited", "filter-values", "business-function-id", "is-selected", "onOnCheck"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.pageMeta.current_page)
          ? (_openBlock(), _createBlock(_component_pagination, {
              key: 0,
              "current-page": _ctx.pageMeta.current_page,
              "total-pages": _ctx.pageMeta.total,
              meta: _ctx.pageMeta,
              onHandleClick: _ctx.navigateToPage
            }, null, 8, ["current-page", "total-pages", "meta", "onHandleClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}